<div role="presentation" class="sp-search-menu">
    <button (click)="openServicePartsSearchDialog()">
        <img src="../../../../../assets/icons/sp-search-tools-wrench.svg">
        <span class="action-label">Find Parts</span>
    </button>
</div>